import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { AgGridReact } from "ag-grid-react";

interface HeaderPopupProps {
  dataSource: any[];
  modalRef?: any;
}

const HeaderPopup = forwardRef(({ dataSource }: HeaderPopupProps, ref) => {
  const gridApiRef = useRef<any>(null);
  const columnDefs = [
    {
      headerName: "항목명",
      field: "headerName",
      width: 200,
      sortable: true,
      editable: true,
      // Add other ag-Grid column properties as needed
    },
  ];
  const [dataSource1, setDataSource1] = useState<any[]>([]);

  useImperativeHandle(ref, () => ({
    getSelectedRow: () => {
      gridApiRef.current?.api?.stopEditing();
      const changedRows = dataSource1.filter((row) => {
        const original = dataSource.find((item) => item.field === row.field);

        // original이 없으면 새로운 항목 → 필요 시 true로 변경
        if (!original) return false;

        // 값 비교 (nm_column 기준)
        return (
          String(row.headerName).trim() !== String(original.headerName).trim()
        );
      });
      if (changedRows.length > 0) {
        return changedRows;
      }

      // 변경된 항목이 없다면 첫 번째 row를 리턴
      return dataSource1.length > 0 ? [dataSource1[0]] : [];
    },
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        // Create a deep copy of dataSource to avoid reference issues
        const filteredData = dataSource
          ? dataSource
              .filter((item) => item.hide !== true && item.headerName !== "No.")
              .map((item) => ({ ...item }))
          : [];
        setDataSource1(filteredData);
      } catch (error) {}
    };
    fetchform();
  }, [dataSource]);

  return (
    <div
      className="h-[400px] ag-theme-alpine"
      style={{
        flex: 1,
        overflow: "hidden",
        marginTop: "10px",
        minHeight: 0,
      }}
    >
      <AgGridReact
        ref={gridApiRef}
        columnDefs={columnDefs}
        rowData={dataSource1}
      />
    </div>
  );
});

export default HeaderPopup;
